
export default {
  name: 'formula-preview',
  props: {
    value: { type: Boolean, default: false }
  },
  computed: {
    opened: function () {
      return this.value;
    }
  },
  methods: {
    close: function () {
      this.$emit('input', false);
    }
  }
};
